<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="130px" label-position="right">
      <el-form-item label="公告标题" prop="title">
        <el-input v-model="formData.title" placeholder="请输入公告标题" @blur="onBlur"></el-input>
      </el-form-item>
      <el-form-item label="公告内容" prop="content">
        <custom-editor ref="editor" @input="onInput" :value="formData.content"></custom-editor>
      </el-form-item>
      <el-form-item prop="fileList">
        <template slot="label">
          <span>公告封面图<br>(1张)</span>
        </template>
        <custom-upload v-model="formData.fileList" :limit="1"></custom-upload>
      </el-form-item>
      <el-form-item label="是否展示到首页" prop="isShow">
        <el-radio-group v-model="formData.isShow" width="110px">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
        &nbsp;&nbsp;&nbsp;<i class="el-icon-info" style="color:#F01919;"></i>&nbsp;
        <span class="grey">选择是后，该公告会在游客小程序首页置顶位置展示</span>
      </el-form-item>
      <el-form-item label="是否立即发布" prop="isPub">
        <el-radio-group v-model="formData.isPub" width="110px">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit" :disabled="disabled">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'NoticeAdd',
  components: {
  },
  data() {
    return {
      disabled: false,
      formData: {
        content: '',
        title: '',
        isShow: '0',
        isPub: '1',
        fileList: []
      },
      rules: {
        title: [
          { required: true, message: '请输入公告标题', trigger: ['blur', 'change'] }
        ],
        isShow: [
          { required: true, message: '请选择是否展示到首页', trigger: ['blur', 'change'] }
        ],
        isPub: [
          { required: true, message: '请选择是是否立即发布', trigger: ['blur', 'change'] }
        ],
        content: [
          { required: true, message: '请输入公告内容', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  created() {
    if (this.id) {
      this.loadData()
    }
  },
  methods: {
    // 富文本加光标
    onBlur() {
      setTimeout(() => {
        this.$refs.editor.editor.focus()
      }, 50)
    },
    loadData() {
      this.$axios.get(this.$apis.tourist.selectNoticeByNoticeId, {
        noticeId: this.id
      }).then(res => {
        this.formData = res || {}
      })
    },
    onInput(value) {
      this.formData.content = value
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.disabled = true
        const url = this.id ? this.$apis.tourist.updateNotice : this.$apis.tourist.insertNotice
        this.$axios.post(url, this.formData).then(() => {
          this.$router.push('/notice')
        }).finally(() => {
          this.disabled = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.grey {
  color: #9A9A9A;
}
</style>
